import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-13",
  "use": "menu-13-usage",
  "viewBox": "0 0 21 20.79",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20.79\" id=\"menu-13\"><title>组 2763</title><g data-name=\"图层 2\"><g data-name=\"图层 1\"><g data-name=\"组 2763\"><path data-name=\"矩形 395\" d=\"M1.8 19.09h17.39a.85.85 0 0 1 .85.85.85.85 0 0 1-.85.85H1.8a.85.85 0 0 1-.8-.85.85.85 0 0 1 .8-.85z\" /><path data-name=\"路径 1341\" d=\"M19.42 0H1.58A1.58 1.58 0 0 0 0 1.58v14a1.58 1.58 0 0 0 1.58 1.58h17.84A1.58 1.58 0 0 0 21 15.6v-14A1.58 1.58 0 0 0 19.42 0zM5.62 13.47a.85.85 0 0 1-1.7 0v-4a.85.85 0 0 1 1.7 0zm3.82 0a.85.85 0 0 1-1.7 0V3.71a.85.85 0 1 1 1.7 0zm3.81 0a.85.85 0 0 1-1.7 0v-2.12a.85.85 0 0 1 1.7 0zm3.82 0a.85.85 0 0 1-1.7 0V5.62a.85.85 0 0 1 1.7 0z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-13.svg
// module id = +xok
// module chunks = 6